import { useQueryClient } from '@tanstack/react-query';
import { PusherEventName } from 'anchor-scout-common/types';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useBusinessChannelEvent } from '~/pusher/useBusinessChannelEvent';
import { useRefreshClientReferenceFields } from './useRefreshClientReferenceFields';
export function useClientSummariesRefresh() {
    const queryClient = useQueryClient();
    const refreshReferenceFields = useRefreshClientReferenceFields();
    useBusinessChannelEvent({
        eventName: PusherEventName.ClientSummaryUpdated,
        source: 'scout',
        callback: ()=>{
            void queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ClientSummaries
                ]
            }, {
                cancelRefetch: false
            });
            refreshReferenceFields();
        }
    });
}
